<template>
	<section class="gaokao-content" style="width: 100%;margin: 20px auto;overflow-y:auto"
		:style="{ height: windowHeight - 140 + 'px' }" @scroll="loadData">
		<div style="width: 1400px;margin: 0 auto;">
			<div class="tb_padding">
				<div class="div_padding">
					<ul>
						<li class=" flex zhong">
							<div class="tba_dl flex zhong">
								<label>用户分数：</label>
								<div class="tba_input">
									<el-input v-model="TestScores" placeholder="请输入" style="width: 218px;"
										@input="GetScores"></el-input>
								</div>
							</div>
							<div class="tba_dl flex zhong">
								<label>选考科目：</label>
								<div class="tba_input">
									<el-select v-model="oneValue" multiple collapse-tags placeholder="请选择首选科目">
										<el-option v-for="item in oneOptions" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
									<el-select v-model="value" multiple collapse-tags style="margin-left: 20px;"
										placeholder="请选择科目">
										<el-option v-for="item in twoOptions" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</div>
							</div>
							<!-- <div class="tba_dl flex zhong"><button class="zhun_btn" @click="getisPop" style="margin-left: 40px;background-color: #333;">分数范围</button></div> -->
						</li>
						<li class=" flex zhong">
							<div class="tba_dl flex zhong">
								<label>批次选择：</label>
								<div class="tba_input">
									<el-select v-model="avalue" multiple collapse-tags placeholder="请选择批次">
										<el-option v-for="item in BatchList" :key="item" :label="item" :value="item">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="tba_dl flex zhong">
								<label>院校名称：</label>
								<div class="tba_input">
									<el-input v-model="searchCollegesName" placeholder="请输入"></el-input>
								</div>
							</div>
							<button style="margin-left: 40px;" class="zhun_btn" @click="serchPage">搜索</button>
							<button class="zhun_btn" @click="restPop">重置</button>
							<!--
                         2.23
                         <div class="tba_dl flex zhong">
							<label>院校地区：</label>
							<div class="tba_input">
								<el-select v-model="twoValue" multiple collapse-tags placeholder="请选择">
									<el-option v-for="item in twoOptions" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
								</el-select>
							</div>
						</div>
                        <div class="tba_dl flex zhong">
                            <button style="margin-left: 40px;" class="zhun_btn" @click="shuaxing()">刷新页面</button>
                            <button class="zhun_btn" @click="SelectList()">确定</button>
                        </div> -->
						</li>
					</ul>
					<!-- 2.22 -->
					<div class="ptyi_xiang">
						<ul>
							<li class="flex float">
								<div class="ptpyx_h6">院校属地</div>
								<div class="ptpyx_you flex wrap">
									<p :class="item.isSelect ? 'on' : ''" @click="onYuanShua(item)"
										v-for="(item, index) in yuanShuList" :key="index">{{ item.name }}</p>
								</div>
							</li>
							<li class="flex float">
								<div class="ptpyx_h6">院校类型</div>
								<div class="ptpyx_you flex wrap">
									<p :class="item.isSelect ? 'on' : ''" @click="onYuanShub(item)"
										v-for="(item, index) in yuanShubList" :key="index">{{ item.name }}</p>
								</div>
							</li>
							<li class="flex float">
								<div class="ptpyx_h6">院校特色</div>
								<div class="ptpyx_you flex wrap">
									<p :class="item.isSelect ? 'on' : ''" @click="onYuanShuc(item)"
										v-for="(item, index) in yuanShucList" :key="index">{{ item.name }}</p>
								</div>
							</li>
							<li class="flex float">
								<div class="ptpyx_h6">院校类别</div>
								<div class="ptpyx_you flex wrap">
									<p :class="item.isSelect ? 'on' : ''" @click="onYuanShud(item)"
										v-for="(item, index) in yuanShudList" :key="index">{{ item.name }}</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="flex zhong" style="margin-top: 30px;">
						<button class="zhun_btn" @click="getisPop">分数范围</button>
						<!-- <button class="zhun_btn" @click="RatePop = true">概率范围</button> -->
					</div>
				</div>

				<div class="state-type flex zhong" v-if="TestScores">
					<p :class="isTab === 1 ? 'on-type' : ''" @click="selectCwb(1)">冲({{ CWB.sco1 || 0 }})</p>
					<p @click="selectCwb(2)" :class="isTab === 2 ? 'on-type' : ''">稳({{ CWB.sco2 || 0 }})</p>
					<p @click="selectCwb(3)" :class="isTab === 3 ? 'on-type' : ''">保({{ CWB.sco3 || 0 }})</p>
				</div>

				<!-- 4.24表格 -->
				<div class="tbc_tabel" v-if="TestScores">
					<div class="pptbiao">
						<!-- 01 -->
						<div class="ppthead flex">
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 50px;">
									<p>{{Column.RateStr || '录取概率'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 50px;">
									<p>{{Column.PositionStr || '志愿位置'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 200px;">
									<p>{{Column.CollegesNameStr || '院校名称'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 60px;">
									<p>{{Column.CollegesAreaStr || '院校地区'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 50px;">
									<p>{{Column.MajorCodeStr || '专业代码'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 157px;">
									<p>{{Column.MajorNameStr || '包含专业'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 100px;">
									<p>{{Column.EducationalStr || '学制/学费'}}</p>
								</div>
							</div>
							<div class="ppt_hli ppt_hlib">
								<div class="ppt_hdd" style="width: 80px;">
									<p>{{Column.NewPlanStr || '计划'}}</p>
								</div>
								<div class="ppt_hdd ppt_hdda">
									<p>{{Column.Year || '2022'}}</p>
								</div>
							</div>
							<div class="ppt_hli ppt_hlib">
								<div class="ppt_hdd" style="width: 228px;">
									<p>{{Column.YearsDateStr || '历年数据'}}</p>
								</div>
								<div class="flex ppt_hddb">
									<div class="ppt_hdd ppt_hdda">
										<p>{{Column.Year1}}</p>
									</div>
									<div class="ppt_hdd ppt_hdda">
										<p>{{Column.Year2}}</p>
									</div>
									<div class="ppt_hdd ppt_hdda">
										<p>{{Column.Year3}}</p>
									</div>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{Column.PreferredSubjectStr || '首选科目'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{Column.RequirementsSubjectsStr || '选考科目'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>{{Column.SolutionStr || '招生简章'}}</p>
								</div>
							</div>
							<div class="ppt_hli">
								<div class="ppt_hdd" style="width: 93px;">
									<p>关注</p>
								</div>
							</div>
						</div>
						<!-- 02 -->
						<div class="pptnei_box" v-if="!isNoData">
							<ul>
								<li class="flex" v-for="(item, index) in tableData" :key="index">
									<div class="pptnei_li" style="width: 50px;">
										<div class="pptnei_view">
											<p>{{item.Rate}}</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 50px;">
										<div>
											<p style="color: #fa4237;" v-if="item.Position == '冲'">冲</p>
											<p style="color: #f3af3b;" v-else-if="item.Position == '稳'">稳</p>
											<p style="color: #42ab3f;" v-else-if="item.Position == '保'">保</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 200px;">
										<div class="pptnei_view">
											<div class="name_div ptname_div " style="width: 100%;">
												<div class="flex zhong">
													<!-- color: #fa4237; -->
													<p style="width: calc(100% - 25px);cursor: pointer; " class="shl"
														@click="showColleges(item.CollegeProfile)">{{item.CollegesName}}
													</p>
													<el-tooltip class="item" :content="item.CollegesName" effect="dark"
														placement="bottom">
														<img src="../../../image/shkl.png"
															style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
													</el-tooltip>
												</div>
												<p>院校代码：{{ item.CollegesCode }}</p>
												<p>院校类别：{{ item.CollegesType }}</p>
												<p>院校类型：{{ item.CollegesMold }}</p>
												<p>特色：{{ item.Characte }}</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 60px;">
										<div class="pptnei_view">
											<p style="color: #000  !important;">{{item.CollegesArea}}</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 50px;">
										<div class="pptnei_view">
											<p style="color: #000  !important;">{{item.MajorCode}}</p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 157px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<div class="flex zhong">
													<p class="flexCenter" style="cursor: pointer;"><span class="zypt"
															@click="zhuanyeTo(item)">查看专业</span></p>
												</div>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 100px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important;">
												<p>{{ item.Educational }}/{{ item.Tuition }}</p>
												</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 80px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important;">{{item.NewPlan}}</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li pptnei_liab" style="width: 228px;">
										<div class="pptnei_view  flex" style="width: 100%;">
											<div class="pptnei_fen">
												<div class="name_div ">
													<p>平均分：{{ item.YearsDate1 != null ? item.YearsDate1.Average : '' }}
													</p>
													<p>最低分：{{ item.YearsDate1 != null ? item.YearsDate1.LowestScore : '' }}
													</p>
													<p>最低位次：{{ item.YearsDate1 != null ? item.YearsDate1.LowestOrder : '' }}
													</p>
												</div>
											</div>
											<div class="pptnei_fen">
												<div class="name_div ">
													<p>平均分：{{ item.YearsDate2 != null ? item.YearsDate2.Average : '' }}
													</p>
													<p>最低分：{{ item.YearsDate2 != null ? item.YearsDate2.LowestScore : '' }}
													</p>
													<p>最低位次：{{ item.YearsDate2 != null ? item.YearsDate2.LowestOrder : '' }}
													</p>
												</div>
											</div>
											<div class="pptnei_fen">
												<div class="name_div ">
													<p>平均分：{{ item.YearsDate3 != null ? item.YearsDate3.Average : '' }}
													</p>
													<p>最低分：{{ item.YearsDate3 != null ? item.YearsDate3.LowestScore : '' }}
													</p>
													<p>最低位次：{{ item.YearsDate3 != null ? item.YearsDate3.LowestOrder : '' }}
													</p>
												</div>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important;">{{item.PreferredSubject}}</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<div class="name_div ">
												<p style="color: #000  !important;">{{item.RequirementsSubjects}}</p>
											</div>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<p><a :href="item.Solution" target="_blank">章程</a></p>
										</div>
									</div>
									<div class="pptnei_li" style="width: 93px;">
										<div class="pptnei_view">
											<img :src="item.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
												class="scImg" style="zoom: 0.7;" @click="CkeUserAttention(index)" />
										</div>
									</div>
								</li>
								<div class="ptend_gao">
									<div class=" ptend_div flexCenter" style="flex-direction: row;padding:15px 0;">
										<img src="../../../image/log.gif"
											style="width: 20px;height: 20px;margin-right: 12px; margin: 0;"
											v-if="BLoading" />
										<span style="margin-top: 0;">{{BLoading?'加载中':'加载已完成'}}</span>
									</div>
								</div>
							</ul>
						</div>
						<div class="ptend_gao" v-if="isNoData">
							<div class=" ptend_div">
								<img src="../../../image/empty.png" />
								<p>暂无数据</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 等效 -->
			<aside class="popup flex zhong center" v-if="isPop">
				<div class="aside_pop " style="position: relative;">
					<img src="../../../image/vol-del-t.png" @click="isPop = false"
						style="display: block;width: 20px;height: 20px;position: absolute;right: 15px;top: 15px;margin: 0;z-index: 1;cursor: pointer;" />
					<div class="aside_div flex zhong">
						<el-input v-model="dengA" style="width:58px;cursor:pointer !important;" readonly="readonly">
						</el-input>
						<div class="flex zhong aside_box">
							<p>{{ valueHua[0] }}</p>
							<div class="block">
								<el-slider v-model="valueHua" @change="setDXScore" range show-stops :min="Min"
									:max="Max"></el-slider>
							</div>
							<p>{{ valueHua[1] }}</p>
						</div>
						<el-input v-model="dengB" style="width:58px;cursor:pointer !important;" readonly="readonly">
						</el-input>
					</div>
					<div class="aside_btn flex zhong center">
						<button class="zhun_btn" @click="heidisPop(1)">还原</button>
						<button class="zhun_btn" @click="heidisPop(2)">确认</button>
					</div>
				</div>
			</aside>

			<!-- 概率 -->
			<aside class="popup flex zhong center" v-if="RatePop">
				<div class="aside_pop " style="position: relative;">
					<img src="../../../image/vol-del-t.png" @click="RatePop = false"
						style="display: block;width: 20px;height: 20px;position: absolute;right: 15px;top: 15px;margin: 0;z-index: 1;cursor: pointer;" />
					<div class="aside_div flex zhong">
						<el-input :value="1" style="width:58px;cursor:pointer !important;" readonly="readonly">
						</el-input>
						<div class="flex zhong aside_box">
							<p>{{ RateHua[0] }}</p>
							<div class="block">
								<el-slider v-model="RateHua" range show-stops :min="1" :max="99"></el-slider>
							</div>
							<p>{{ RateHua[1] }}</p>
						</div>
						<el-input :value="99" style="width:58px;cursor:pointer !important;" readonly="readonly">
						</el-input>
					</div>
					<div class="aside_btn flex zhong center">
						<button class="zhun_btn" @click="restRate">还原</button>
						<button class="zhun_btn" @click="refullRate">确认</button>
					</div>
				</div>
			</aside>
			<!-- 专业 -->
			<!-- <aside class="popup flex zhong center" v-if="isZyPop">
				<div class="aside_pop">
					<div class="aside_height" v-if="zyList.length>0">
						<ul>
							<li v-for="(item, index) in zyList" :key="index" @click="setMajorName(item)">
								{{ item.MajorName }}
							</li>
						</ul>
					</div>
					<div class="ptend_gao" v-else>
						<div class=" ptend_div">
							<img src="../../../image/empty.png" />
							<p>暂无数据</p>
						</div>
					</div>
					<div class="aside_btn flex zhong center"><button class="zhun_btn"
							@click="isZyPop = false">关闭</button></div>
				</div>
			</aside> -->
			<!-- 院校 -->
			<aside class="popup flex zhong center" v-if="isYxPop">
				<div class="aside_pop">
					<div class="aside_height" v-if="yxList.length>0">
						<ul>
							<li v-for="(item, index) in yxList" :key="index" v-on:click="xueTo(item.Name)">
								{{ item.Name }}
							</li>
						</ul>
					</div>
					<div class="ptend_gao" v-else>
						<div class=" ptend_div">
							<img src="../../../image/empty.png" />
							<p>暂无数据</p>
						</div>
					</div>
					<div class="aside_btn flex zhong center"><button class="zhun_btn"
							@click="isYxPop = false">关闭</button></div>
				</div>
			</aside>

			<aside class="popup flexCenter" v-if="isZhuan">
				<div class="ptzhuan_bai">
					<img src="../../../image/vol-del-t.png" @click="isZhuan = false" />
					<div class="ptzhuan_h6">选择专业</div>
					<div style="height: 400px;overflow: auto;" v-if="!ZyNoData">
						<div class="ptzhuan_list flex wrap">
							<p :title="item.Name" v-for="(item, index) in zhuanList" :key="index"
								@click="goMajorName(item)">{{ item.Name }}</p>
						</div>
					</div>
					<div class="ptend_gao" v-else>
						<div class=" ptend_div">
							<img src="../../../image/empty.png" />
							<p>暂无数据</p>
						</div>
					</div>
				</div>
			</aside>
		</div>
		
		<el-dialog width="1200px" :title="CollegeMajorName" :visible.sync="isZyPop" :close-on-click-modal="false" top="50px">
			<college-major :list="CollegeMajorlist" :columnName="Column" :iszntb="false" @showMajorDetail="showMajorDetail"></college-major>
		</el-dialog>
		
	</section>
</template>

<script>
	import CollegeMajor from '../yunYing/CollegeMajor.vue';
	import infiniteScroll from 'vue-infinite-scroll';
	export default {
		directives: {
			infiniteScroll
		},
		components: {
			CollegeMajor
		},
		data() {
			return {
				CollegeMajorName:'',
				CollegeMajorlist:[],
				ZyNoData: false,
				zhuanList: [],
				isZhuan: false,
				BLoading: true,
				isNoData: false,
				isYxPop: false,
				yxList: [],
				loadinga: false,
				windowHeight: document.documentElement.clientHeight,
				RatePop: false, // 概率弹窗
				RateMax: 0,
				RateMin: 0,
				RateHua: [1, 99],
				RateA: 0,
				RateB: 100,
				Min: 0,
				Max: 0,
				total: 0,
				Column: {},
				isPop: false,
				isZyPop: false,
				valueHua: [0, 0],
				twoValue: [],
				dengA: '-150',
				dengB: '+150',
				TestScores: '',
				tableData: [],
				loading: false,
				busy: true,
				Nobusy: false,
				page: 1,
				listData: [],
				PreferredSubject: '', // 首选科目
				RequirementsSubjects: '', // 选考科目
				searchMajorName: '', // 专业名称
				searchCollegesName: '', // 院校名称
				searchCitysCode: '', // 院校地区
				StduentScore: 0, // 用户默认等效分
				MinScore: '', // 等效分
				MaxScore: '', // 等效分
				stMajoScore: 0,
				endMajoScore: 0,
				// 2.23
				options: [],
				value: '',
				oneOptions: [],
				twoOptions: [],
				threeOptions: [],
				twoOptionss: [],
				BatchList: [], // 批次选择
				oneValue: '',
				aoptions: [{
					value: '选项1',
					label: '黄金糕'
				}],
				avalue: '',
				isTab: 0,
				// 22-2-14
				isYuanShua: 0,
				yuanShuList: [{
						id: 0,
						isSelect: true,
						name: '不限'
					},
					{
						id: 1,
						isSelect: false,
						name: '北京市'
					},
					{
						id: 2,
						isSelect: false,
						name: '河北省'
					},
					{
						id: 3,
						isSelect: false,
						name: '山西省'
					},
					{
						id: 4,
						isSelect: false,
						name: '辽宁省'
					},
					{
						id: 5,
						isSelect: false,
						name: '吉林省'
					},
					{
						id: 6,
						isSelect: false,
						name: '黑龙江省'
					},
					{
						id: 7,
						isSelect: false,
						name: '江苏省'
					},
					{
						id: 8,
						isSelect: false,
						name: '浙江省'
					},
					{
						id: 9,
						isSelect: false,
						name: '安徽省'
					},
					{
						id: 10,
						isSelect: false,
						name: '福建省'
					},
					{
						id: 11,
						isSelect: false,
						name: '江西省'
					},
					{
						id: 12,
						isSelect: false,
						name: '山东省'
					},
					{
						id: 13,
						isSelect: false,
						name: '河南省'
					},
					{
						id: 14,
						isSelect: false,
						name: '湖北省'
					},
					{
						id: 15,
						isSelect: false,
						name: '湖南省'
					},
					{
						id: 16,
						isSelect: false,
						name: '广东省'
					},
					{
						id: 17,
						isSelect: false,
						name: '海南省'
					},
					{
						id: 18,
						isSelect: false,
						name: '四川省'
					},
					{
						id: 19,
						name: '贵州省',
						isSelect: false
					},
					{
						id: 0,
						name: '云南省',
						isSelect: false
					},
					{
						id: 21,
						name: '陕西省',
						isSelect: false
					},
					{
						id: 22,
						name: '甘肃省',
						isSelect: false
					},
					{
						id: 23,
						name: '青海省',
						isSelect: false
					},
					{
						id: 24,
						isSelect: false,
						name: '台湾省'
					},
					{
						id: 25,
						isSelect: false,
						name: '内蒙古'
					},
					{
						id: 26,
						isSelect: false,
						name: '广西壮族'
					},
					{
						id: 27,
						isSelect: false,
						name: '西藏'
					},
					{
						id: 28,
						isSelect: false,
						name: '宁夏回族'
					},
					{
						id: 29,
						isSelect: false,
						name: '新疆维吾尔'
					},
					{
						id: 30,
						isSelect: false,
						name: '天津市'
					},
					{
						id: 31,
						isSelect: false,
						name: '上海市'
					},
					{
						id: 32,
						isSelect: false,
						name: '重庆市'
					},
					{
						id: 33,
						isSelect: false,
						name: '香港'
					},
					{
						id: 34,
						isSelect: false,
						name: '澳门'
					}
				],
				isYuanShub: 0,
				yuanShubList: [{
						id: 0,
						isSelect: true,
						name: '不限'
					},
					{
						id: 1,
						isSelect: false,
						name: '综合'
					},
					{
						id: 2,
						isSelect: false,
						name: '理工'
					},
					{
						id: 3,
						isSelect: false,
						name: '财经'
					},
					{
						id: 4,
						isSelect: false,
						name: '军事'
					},
					{
						id: 5,
						isSelect: false,
						name: '民族'
					},
					{
						id: 6,
						isSelect: false,
						name: '农林'
					},
					{
						id: 7,
						isSelect: false,
						name: '师范'
					},
					{
						id: 8,
						isSelect: false,
						name: '体育'
					},
					{
						id: 9,
						isSelect: false,
						name: '医药'
					},
					{
						id: 10,
						isSelect: false,
						name: '艺术'
					},
					{
						id: 11,
						isSelect: false,
						name: '语言'
					},
					{
						id: 12,
						isSelect: false,
						name: '政法'
					},
					{
						id: 13,
						isSelect: false,
						name: '其他'
					}
				],
				isYuanShuc: 0,
				yuanShucList: [{
						id: 0,
						isSelect: true,
						name: '不限'
					},
					{
						id: 1,
						isSelect: false,
						name: '985'
					},
					{
						id: 2,
						isSelect: false,
						name: '211'
					},
					{
						id: 3,
						name: '双一流',
						isSelect: false
					},
					{
						id: 4,
						isSelect: false,
						name: '国家重点'
					},
					{
						id: 5,
						isSelect: false,
						name: '省重点'
					}
				],
				isYuanShud: 0,
				yuanShudList: [{
						id: 0,
						isSelect: true,
						name: '不限'
					},
					{
						id: 1,
						isSelect: false,
						name: '公办'
					},
					{
						id: 2,
						isSelect: false,
						name: '民办'
					},
					{
						id: 3,
						isSelect: false,
						name: '中外/港澳'
					}
				],
				yxloading: null,
				isPage: false,
				isYanPage: false, // 是否加载中
				user: {},
				CWB: {},
				form: {}
			};
		},
		created() {
			var that = this;
			if (that.$route.query.key) {
				that.$api.reduceUserCount({
					key: that.$route.query.key
				});
			} else {
				that.$router.back(-1);
			}
			var user = that.$store.state.user.user || {};
			if (user && user.Id) {
				that.user = user;
			}
			that.$api.HtppRequest(
				'Accurate/GetColumnName',
				'GET', {},
				function(res) {
					console.log('获取信息', res);
					if (res.code === 0) {
						that.Column = res.data;
						that.IsPage = true;
						console.log(that.Column);
						// setTimeout(() => {
						// 	that.tableScrollListener();
						// }, 1000);
					}
				},
				function(err) {
					console.log(err);
				}
			);
			that.GetUserScore();
			that.getRegionByPid(0);
			that.getConditions(); // 获取选考科目
			that.getAdmissionBatch(); // 获取批次选择
			// that.getAdmissionPage(1);
		},
		mounted() {
			window.scrollTo(0, 0);
		},
		methods: {
			setMajorName(item) {
				this.zhuanList = item.MajorProfile;
				this.ZyNoData = this.zhuanList.length === 0;
				this.isZhuan = true;
			},
			// vueshowloading() {
			// 	this.yxloading = this.$loading({
			// 		lock: true,
			// 		text: 'Loading',
			// 		spinner: 'el-icon-loading',
			// 		background: 'rgba(0, 0, 0, 0.7)'
			// 	});
			// },
			// vuedelloading() {
			// 	if (this.yxloading) {
			// 		console.log('关闭');
			// 		this.yxloading.close();
			// 		this.yxloading = null;
			// 	}
			// },
			loadData(e) {
				// console.log('滚动', e.srcElement.scrollTop + e.srcElement.clientHeight, e.srcElement.scrollHeight);
				if (e.srcElement.scrollTop + e.srcElement.clientHeight >= e.srcElement.scrollHeight) {
					console.log('嘿嘿我在底部触发了', this.isYanPage);
					if (!this.isYanPage && this.tableData.length > 0) {
						// 加载中
						this.isYanPage = true;
						this.loadMore();
						// this.vueshowloading();
					}
				}
			},
			zhuanyeTo(rows) {
				var that = this;
				console.log('院校', rows);
				// 2022-07-08 15:58 张燕说和一键只能填报院校相同
				console.log('111111111111', rows);
				that.$api.HtppRequest(
					'Accurate/GetProfession',
					'POST', {
						page: 1,
						pageSize: 999999999,
						CWBType: 0,
						CandidatesType: that.candidatesType,
						CollegesName: rows.CollegesName,
						isAll: true
					},
					function(res) {
						console.log('获取列表', res);
						if (res.code === 0) {
							that.CollegeMajorName = rows.CollegesName;
							that.CollegeMajorlist= res.data;
							that.isZyPop = true;
						}
						
					},
					function(err) {}
				);
			},
			goMajorName(item) {
				// this.$router.push({
				// 	path: '/majorinfo',
				// 	query: {
				// 		Id: item.Id
				// 	}
				// });
				if (item.Id > 0) {
					window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${item.Id}`);
				}
			},
			// 获取
			getAdmissionBatch() {
				var that = this;
				// + this.user.ProvinceCode
				that.$api.HtppRequest(
					'Accurate/Profession/AdmissionBatch?CityCodes=' + that.user.ProvinceCode,
					'GET', {},
					function(res) {
						if (res.code === 0) {
							that.BatchList = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取筛选条件的数据
			async getConditions() {
				var form = {
					CityCodes: this.user.ProvinceCode
				};
				const resArr = await Promise.all([this.$api.getPreferredSubject(form), this.$api
					.getRequirementsSubjects(form), this.$api.getAccurateCity()
				]);
				console.log('resArr', resArr);
				resArr.forEach((res, index) => {
					switch (index) {
						case 0:
							this.oneOptions = res.data;
							break;
						case 1:
							this.twoOptions = res.data;
							break;
						case 2:
							this.threeOptions = res.data;
							break;
					}
				});
			},
			onYuanShua(item) {
				// this.isYuanShua = index;
				if (item.id === 0) {
					this.yuanShuList.forEach(a => {
						a.isSelect = false;
					});
					item.isSelect = true;
				} else {
					this.yuanShuList[0].isSelect = false;
					item.isSelect = !item.isSelect;
				}
			},
			onYuanShub(item) {
				// this.isYuanShub = index;
				if (item.id === 0) {
					this.yuanShubList.forEach(a => {
						a.isSelect = false;
					});
					item.isSelect = true;
				} else {
					this.yuanShubList[0].isSelect = false;
					item.isSelect = !item.isSelect;
				}
			},
			onYuanShuc(item) {
				// this.isYuanShuc = index;
				if (item.id === 0) {
					this.yuanShucList.forEach(a => {
						a.isSelect = false;
					});
					item.isSelect = true;
				} else {
					this.yuanShucList[0].isSelect = false;
					item.isSelect = !item.isSelect;
				}
			},
			onYuanShud(item) {
				// yuanShudList
				// this.isYuanShud = index;
				if (item.id === 0) {
					this.yuanShudList.forEach(a => {
						a.isSelect = false;
					});
					item.isSelect = true;
				} else {
					this.yuanShudList[0].isSelect = false;
					item.isSelect = !item.isSelect;
				}
			},
			// table触底加载更多
			tableScrollListener() {
				console.log('table触底加载更多');
				const dom = document.querySelector('.el-table__body-wrapper');
				dom.addEventListener('scroll', () => {
					const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
					if (scrollDistance <= 5) {
						if (this.timer) {
							clearTimeout(this.timer);
							this.timer = null;
						}
						this.timer = setTimeout(() => {
							this.timer = null;
							this.loadMore();
						}, 200);
					}
				});
			},
			getisPop() {
				var that = this;
				if (that.TestScores.length === 0) {
					that.$util.showError('请输入考分');
					return false;
				}
				console.log('显示等效分');
				that.GetStduentScore(function() {
					that.isPop = true;
				});
			},
			setDXScore() {
				console.log('拖动结束');
				// this.MinScore = this.StduentScore + this.valueHua[0]; // 等效分
				// this.MaxScore = this.StduentScore + this.valueHua[1]; // 等效分
				this.MinScore = this.valueHua[0]; // 等效分
				this.MaxScore = this.valueHua[1]; // 等效分
				console.log('this.MinScore/', this.MinScore);
				console.log('this.MaxScore/', this.MaxScore);
			},
			//  拖动概率分
			setRateScore() {
				console.log('拖动结束');
				// this.MinScore = this.StduentScore + this.valueHua[0]; // 等效分
				// this.MaxScore = this.StduentScore + this.valueHua[1]; // 等效分
				this.RateMin = this.RateHua[0]; // 等效分
				this.RateMax = this.RateHua[1]; // 等效分
				console.log('this.MinScore/', this.MinScore);
				console.log('this.MaxScore/', this.MaxScore);
			},
			// 还原概率分
			restRate() {
				this.RateHua = [0, 100];
				this.RateMin = 0;
				this.RateMax = 1;
				// this.RatePop = false;
			},
			refullRate() {
				this.RateMin = this.RateHua[0];
				this.RateMax = this.RateHua[1];
				this.RatePop = false;
			},
			GetUserScore() {
				var that = this;
				that.$api.HtppRequest(
					'Accurate/GetMajorScore?UserId=' + that.$store.state.user.user.Id,
					'Post', {},
					function(res) {
						console.log('获取等效分', res);
						if (res.code === 0) {
							that.stMajoScore = parseFloat(res.data.stMajoScore);
							that.endMajoScore = parseFloat(res.data.endMajoScore);

							that.valueHua[0] = that.stMajoScore;
							that.valueHua[1] = that.endMajoScore;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			GetScores() {
				var that = this;
				that.GetStduentScore(function() {
					that.getAdmissionPage(1);
				});
			},
			// 根据分数获取等效分
			GetStduentScore(next) {
				var that = this;
				that.$api.HtppRequest(
					'Accurate/GetStduentScore?UserId=' + that.$store.state.user.user.Id + '&TotalScore=' + parseFloat(
						that.TestScores),
					'Post', {},
					function(res) {
						if (res.code === 0) {
							that.StduentScore = parseFloat(res.data.score);
							that.MinScore = that.StduentScore + that.stMajoScore; // 等效分
							that.MaxScore = that.StduentScore + that.endMajoScore; // 等效分
							that.valueHua[0] = that.MinScore;
							that.valueHua[1] = that.MaxScore;
							that.Min = that.StduentScore - 150;
							that.Max = that.StduentScore + 150;
							console.log(that.valueHua);
							next();
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			getRegionByPid(pid) {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetRegionByPid?pid=' + pid,
					'GET', {},
					function(res) {
						console.log('省份', res);
						if (res.flag) {
							var clist = res.list;
							that.twoOptionss = clist;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			SelectList() {
				var that = this;
				if (that.TestScores.length === 0) {
					that.$util.showError('请输入考分');
					return false;
				}
				that.searchCitysCode = ''; // 院校地区
				if (that.twoValue.length > 0) {
					console.log(that.twoValue);
					that.searchCitysCode = that.twoValue.join(',');
				}
				if (that.StduentScore > 0) {
					that.getAdmissionPage(1);
				} else {
					that.GetStduentScore(function() {
						that.getAdmissionPage(1);
					});
				}
			},
			current_change: function(currentPage) {
				this.page = currentPage;
				this.getAdmissionPage(currentPage);
			},
			selectCwb(index) {
				if (index === this.isTab) {
					return;
				}
				this.isTab = index;
				this.getAdmissionPage(1);
			},
			serchPage() {
				var that = this;
				var oneValue = '';
				var value = '';
				var avalue = '';
				if (that.oneValue && that.oneValue.length > 0) {
					oneValue = that.oneValue
						.map(a => {
							return a;
						})
						.join(',');
				}
				if (that.value && that.value.length > 0) {
					value = that.value
						.map(a => {
							return a;
						})
						.join(',');
				}
				if (that.avalue && that.avalue.length > 0) {
					avalue = that.avalue
						.map(a => {
							return a;
						})
						.join(',');
				}
				var searchCitysCode = '';
				if (that.yuanShuList && that.yuanShuList.length > 0) {
					searchCitysCode = that.yuanShuList
						.filter(a => {
							if (a.isSelect) {
								return a;
							}
						})
						.map(b => {
							return b.name;
						})
						.join(',');
					if (searchCitysCode === '不限') {
						searchCitysCode = '';
					}
				}
				var CollegesType = '';
				if (that.yuanShubList && that.yuanShubList.length > 0) {
					CollegesType = that.yuanShubList
						.filter(a => {
							if (a.isSelect) {
								return a;
							}
						})
						.map(b => {
							return b.name;
						})
						.join(',');
					if (CollegesType === '不限') {
						CollegesType = '';
					}
				}
				var CollegesMold = '';
				if (that.yuanShucList && that.yuanShucList.length > 0) {
					CollegesMold = that.yuanShucList
						.filter(a => {
							if (a.isSelect) {
								return a;
							}
						})
						.map(b => {
							return b.name;
						})
						.join(',');
					if (CollegesMold === '不限') {
						CollegesMold = '';
					}
				}
				var Characte = '';
				if (that.yuanShudList && that.yuanShudList.length > 0) {
					Characte = that.yuanShudList
						.filter(a => {
							if (a.isSelect) {
								return a;
							}
						})
						.map(b => {
							return b.name;
						})
						.join(',');
					if (Characte === '不限') {
						Characte = '';
					}
				}
				that.form = {
					PreferredSubject: oneValue,
					RequirementsSubjects: value,
					searchMajorName: avalue,
					searchCitysCode: searchCitysCode,
					CollegesType: CollegesType,
					CollegesMold: CollegesMold,
					Characte: Characte
				};
				that.isYanPage = false;
				that.getAdmissionPage(1);
			},
			restPop() {
				var that = this;
				that.MinScore = '';
				that.MaxScore = '';
				that.TestScores = '';
				that.isTab = '';
				that.restRate();
				that.form = {};
				that.yuanShuList.forEach(a => {
					a.isSelect = false;
					if (a.name === '不限') {
						a.isSelect = true;
					}
				});
				that.yuanShubList.forEach(a => {
					a.isSelect = false;
					if (a.name === '不限') {
						a.isSelect = true;
					}
				});
				that.yuanShucList.forEach(a => {
					a.isSelect = false;
					if (a.name === '不限') {
						a.isSelect = true;
					}
				});
				that.yuanShudList.forEach(a => {
					a.isSelect = false;
					if (a.name === '不限') {
						a.isSelect = true;
					}
				});
				that.getAdmissionPage(1);
			},
			getAdmissionPage(pg) {
				var that = this;
				if (!that.TestScores) {
					console.log('总分数', that.TestScores);
					// that.vuedelloading();
					that.IsPage = false;
					that.isYanPage = false;
					return;
				}
				that.$api.HtppRequest(
					'Accurate/GetAdmission',
					'POST', {
						page: pg,
						pageSize: 10,
						UserId: that.$store.state.user.user.Id,
						SelectId: this.$parent.firstId, // 意向选择Id
						IsCollegesAreas: false,
						IsMajorNames: false,
						IsCollegesNames: false,
						PreferredSubject: that.form.PreferredSubject, // 首选科目
						RequirementsSubjects: that.form.RequirementsSubjects, // 选考科目
						searchMajorName: that.form.searchMajorName, // 专业名称
						searchCollegesName: that.searchCollegesName, // 院校名称
						MinScore: that.MinScore, // 等效分范围
						MaxScore: that.MaxScore, // 等效分范围
						Score: that.TestScores, // 等效分
						CWBType: that.isTab, // 冲稳保查询 1=冲 2=稳 3=保
						RateMin: that.RateMin, // 最小概率
						RateMax: that.RateMax, // 最大概率
						TotleScore: that.TestScores, // 总分
						searchCitysCode: that.form.searchCitysCode,
						CollegesType: that.form.CollegesType,
						CollegesMold: that.form.CollegesMold,
						Characte: that.form.Characte
					},
					function(res) {
						console.log('获取列表', res);
						if (res.code === 0) {
							if (pg === 1) {
								that.tableData = [];
							}
							if (res.data.length > 0) {
								res.data.map(a => {
									that.tableData.push(a);
								});
								that.page = res.data.length > 0 ? pg : that.page;
								that.total = res.totalCount;
								that.BLoading = res.data.length === 10;
								that.isYanPage = false;
							}
							that.CWB = res.cwb;
						}
						setTimeout(() => {
							// that.vuedelloading();
							that.IsPage = false;
						}, 500);
						that.isNoData = that.tableData.length === 0;
					},
					function(err) {
						console.log(err);
						if (pg === 1) {
							that.tableData = [];
						}
						// that.vuedelloading();
						that.IsPage = false;
						that.isYanPage = false;
						that.isNoData = that.tableData.length === 0;
					}
				);
			},
			heidisPop(type) {
				var that = this;
				if (type === 1) {
					that.GetStduentScore(function() {
						that.isPop = false;
					});
				} else {
					that.isPop = false;
				}
			},
			// 收藏院校
			CkeUserAttention(ixd) {
				console.log('下标：' + ixd);
				var that = this;
				that.$api.HtppRequest(
					'Accurate/AttentionAdd?UserId=' + that.$store.state.user.user.Id + '&ContentId=' + that.tableData[
						ixd].Id + '&Type=1',
					'GET', {},
					function(res) {
						console.log('关注信息', res);
						if (res.code === 0) {
							that.$util.showOk(res.msg);
							if (that.tableData[ixd].UserAttention) {
								that.tableData[ixd].UserAttention = false;
							} else {
								that.tableData[ixd].UserAttention = true;
							}
							that.$forceUpdate();
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 显示专业介绍
			showMajorDetail(scope) {
				console.log('专业点击了',scope);
				this.setMajorName(scope.row);
				// if (scope.row.MajorProfile) {
				// 	this.majorDetail = scope.row.MajorProfile;
				// } else {
				// 	this.majorDetail = scope;
				// }
				// this.isZyPop = true;
			},
			loadMore() {
				// this.loadinga = true;
				console.log('加载跟多');
				var pg = parseInt(this.page) + 1;
				if (this.BLoading) {
					this.getAdmissionPage(pg);
				}
			},
			showColleges(list) {
				var that = this;
				if (list) {
					that.yxList = list;
				}
				that.isYxPop = true;
			},
			xueTo(schoolname) {
				if (schoolname) {
					window.open(
						`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${schoolname}`);
				}
			}
		}
	};
</script>
<style scoped>
	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.tbc_tabel.active /deep/.el-table--border td {
		background-color: #fff4ee;
	}

	/deep/.el-table thead.is-group th {
		background-color: #bddcf6;
	}

	/deep/.el-table--border td {
		background-color: #ddebf7;
	}

	.name_div>p {
		font-size: 12px !important;
		color: #999 !important;
		text-align: left !important;
	}

	.name_div>p span {
		color: #666 !important;
	}

	.table img.scImg {
		display: block;
		width: 20px;
		height: 20px;
		margin: 0 auto;
		cursor: pointer;
	}

	.table p {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	/deep/.el-table td,
	/deep/.el-table th {
		padding: 5px 0 !important;
	}

	/deep/.cell {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
		color: #666666;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */

	.tbc_tabel {
		width: 100%;
		margin-top: 30px;
		/* min-height: 400px; */
		height: auto;
		overflow: auto;
		overflow-x: hidden;
	}

	/* tbc_tabel */

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */

	/deep/.el-slider__button-wrapper:nth-child(2)::before {
		content: '-';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button-wrapper:nth-child(3)::before {
		content: '+';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button {
		width: 24px;
		height: 24px;
		background-color: #fff;
		border: solid 1px #dddddd;
		border-radius: 4px;
	}

	/deep/.el-slider__bar {
		background-color: #f3af3b;
	}

	/deep/.el-slider__runway {
		background-color: #fce4d6;
	}

	/deep/.el-slider__stop {
		background-color: transparent;
	}

	.block {
		width: 360px;
		margin: 0 20px;
	}

	.aside_div /deep/input {
		padding: 0 !important;
		text-align: center;
	}

	.tba_dl p {
		font-size: 14px;
		color: #333;
		margin: 0 10px;
	}

	.tba_dl label {
		font-size: 14px;
		color: #333;
		width: 80px;
		text-align: right;
		margin-right: 10px;
	}

	.tba_dl {
		min-width: 50px;
	}

	.div_padding li:nth-child(n + 2) {
		margin-top: 5px;
	}

	.zhun_btn.on {
		background-color: #005371;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	/* zhun_btn */

	.div_padding {
		padding: 20px;
		width: 100%;
		border: solid 1px #dddddd;
		margin: 20px 0;
	}

	/* div_padding */

	.three_div p.on {
		background-color: #333;
		color: #fff;
	}

	.three_div p {
		width: 180px;
		height: 40px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		border: solid 1px #dddddd;
		border-bottom: none;
		font-size: 16px;
		color: #333;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.three_div {
		margin: 20px 0;
		border-bottom: solid 2px #333;
	}

	/* three_div */
	.tb_padding {
		padding: 20px 20px 1px 20px;
	}

	.gkTest-step {
		margin-top: 0;
	}

	.gaokao-content {
		background-color: #fff;
		padding-bottom: 40px;
		overflow-x: hidden;
	}

	.shuJu {
		font-size: 14px;
		padding: 15px 0 0 0;
	}

	/* 2.23 */

	/* state-type */
	.state-type {
		width: 100%;
		height: auto;
	}

	.state-type p {
		font-size: 15px;
		color: #333;
		width: 80px;
		text-align: center;
		position: relative;
		cursor: pointer;
	}

	.state-type p::after {
		position: absolute;
		content: '';
		width: 40px;
		height: 0;
		border-bottom: 3px solid transparent;
		border-radius: 50px;
		bottom: 0;
		left: 50%;
		margin-left: -20px;
	}

	.state-type .on-type {
		color: #0079fe;
		font-weight: bold;
	}

	.state-type .on-type::after {
		border-bottom: 3px solid #0079fe;
	}

	.zypt {
		display: inline-block;
		padding-bottom: 10px;
		border-bottom: solid 1px #94918f;
		cursor: pointer;
	}

	.jiazai {
		font-size: 14px;
		color: #666;
		text-align: center;
		padding: 30px 0;
	}
</style>
